import React from "react";
import styles from "./supportBox.module.scss";
import RightArrow from "../../assets/editor/rightArrow.svg";

const SupportBox = (props) => {
  const { text, subtext, linkText, icon, backgroundColor, href } = props;

  return (
    <React.Fragment>
      <a className={styles.supportBox} href={href} style={{ backgroundColor }}>
        <div className={styles.supportBoxIcon}>
          <img src={icon} alt={""} />
        </div>
        <div className={styles.supportBoxTextArea}>
          <div className={styles.supportBoxText}>{text}</div>
          <div className={styles.supportBoxSubtext}>{subtext}</div>
          <div className={styles.supportBoxLink}>
            <div className={styles.supportBoxLinkText}>{linkText}</div>
            <img
              src={RightArrow}
              className={styles.supportBoxLinkArrow}
              alt={""}
            />
          </div>
        </div>
      </a>
    </React.Fragment>
  );
};

export default SupportBox;
